import type { NoteSeverity } from "../types.ts";

export const SEVERITIES: NoteSeverity[] = ["critical", "warning", "info"];

export const SEVERITY_RANK: Record<NoteSeverity, number> = {
	critical: 0,
	warning: 1,
	info: 2,
};

export const SEVERITY_LABELS: Record<NoteSeverity, string> = {
	info: "Informativo",
	warning: "Atenção",
	critical: "Crítico",
};

export function higherSeverity(
	a: NoteSeverity | undefined,
	b: NoteSeverity,
): NoteSeverity {
	if (!a) return b;
	return SEVERITY_RANK[b] < SEVERITY_RANK[a] ? b : a;
}
